import {SimpleApi, isResolved, urlEncode, runWhile} from '@oc/utils'
import axios from 'axios'

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export const AUTOMATICALLY_SELECTED_PLAN = 'standard'

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface Account {
    accountId: string
    name: string
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface Customer {
    quotationNumberKrones: any
    quotationNumberSyskron: any
    street: any
    city: any
    stateName: any
    country: any
    zipCode: any
    latitude: any
    longitude: any
    customerTimezone: string | null
    orderNumbersKrones: string[]
    orderNumbersSyskron: string[]
    s2aAccountName: string
    links: string[]
    version: number
    customerNumber: string
    salesRepresentative: string
    rkMonitoringHidden?: boolean
    accountProperties?: AccountProperties
    preferredLanguages?: string[]
    serviceGroups: string[]
    readyKitCount: number
    salesRegion?: string
}

/**
 * @deprecated Library @oc/customers-v2 should be used to work with Customers/Accounts
 */
export interface ListCustomersResponse {
    items: Array<Customer>
    lastEvaluatedKey?: string
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface S2aReadyKitProperties {
    [key: string]: string
    name: string
    cNumber: string
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface AccountProperties {
    [key: string]: string
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface Plan {
    planKey: string
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface Tenant {
    tenantId: string // uuid
    tenantName: string
    description: string
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface S2aBookedService {
    serviceId: string
    plan: Plan
    additionalProperties?: {[key: string]: unknown}
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export enum S2aAccountState {
    Inactive = 'inactive',
    Active = 'active',
    Offboarding = 'offboarding',
    Offboarded = 'offboarded',
    Restore = 'restore'
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface S2aAccount {
    accountId: string
    tenant?: Tenant
    services: S2aBookedService[]
    state: S2aAccountState
    deactivateComment?: string
    /** ISO datetime in UTC timezone */
    deactivatedAt?: string
    /** ISO datetime in UTC timezone */
    usersDataDeleteAt?: string
    /** ISO datetime in UTC timezone */
    offBoardingStartedAt?: string
    notifier?: string
    notifierEmail?: string
    telephoneNumber?: string
    personnelNumber?: string
    ecosystem?: Ecosystem
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface S2aService {
    serviceId: string
    name: string
    plans: S2aPlan[]
    additionalProperties?: {
        key: string
        type: string // string, object, enumeration, array
        values?: unknown[] // for enum only
        required: boolean
    }[]
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface S2aPlan {
    key: string
    features: string[]
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface CreateCustomerResponse {
    progressToken: string
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface GetCreateCustomerProgressResponse {
    status: string
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface BookedService {
    id: string
    planKey: string
    name: string
    params?: {
        key: string
        type: string
        value: unknown
        values?: unknown
        required: boolean
    }[]
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface CommentedAccount {
    id: string
    commentInactive: string
    commentDeleted: string
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface AvailableGroup {
    id: string
    default?: boolean
    displayName: string
    requiredOcServices: string[]
    optionalOcServices: string[]
    requiredS2aServices: string[]
    optionalS2aServices: string[]
    defaultOptionalS2aServices?: string[]
}

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export interface RegionCountry {
    region: string
    country: string
}

export enum Ecosystem {
    Share2Act = 'share2act',
    Flash = 'flash'
}

export interface EcosystemOption {
    label: string
    value: string
}

export const ecosystemOptions: EcosystemOption[] = Object.entries(Ecosystem).map(([key, value]) => {
    return {label: key, value: value}
})

const gatewayApiName = 'IbtAPIGateway'
const ocPermissionGatewayApiName = 'oc-permissions'
const iamOperationsGatewayApiName = 'iamOperations'

/**
 * @deprecated Library '@oc/customer-v2' should be used to work with Customers/Accounts
 */
export class CustomerService {
    /**
     * Get all customers
     *
     * @returns Promise to return all customers
     */
    public async getCustomers(): Promise<Customer[]> {
        const customers: Array<Customer> = []
        let lastEvaluatedKey: string | undefined = undefined
        let params = {}

        await runWhile(async () => {
            if (lastEvaluatedKey) {
                params = {
                    queryParams: {
                        lastEvaluatedKey
                    }
                }
            }
            const page = (await SimpleApi.get(gatewayApiName, '/customer', params)) as ListCustomersResponse

            lastEvaluatedKey = page.lastEvaluatedKey

            customers.push(...page.items)

            return !!lastEvaluatedKey
        }, 0)

        return customers
    }

    /**
     * Get customer by id (s2aAccountName)
     *
     * @returns Promise to return customer by id
     */
    public async getCustomerById(customerId: string): Promise<Customer> {
        const path = urlEncode`/customer/${customerId}`
        return await SimpleApi.get(gatewayApiName, path)
    }

    /**
     * Get customer device instance ids
     *
     * @returns Promise to return instance ids
     */
    public async getCustomerInstanceIds(customerId: string): Promise<Map<string, string>> {
        const path = urlEncode`/customer/${customerId}/devices`
        const dictionary = await SimpleApi.get(gatewayApiName, path)
        return new Map<string, string>(Object.entries(dictionary))
    }

    public async getAvailableGroups(): Promise<AvailableGroup[]> {
        return (await SimpleApi.get(gatewayApiName, '/equipment-services/service-list')).serviceGroups
    }

    public async getS2aAccount(accountId: string): Promise<S2aAccount | undefined> {
        try {
            return await SimpleApi.get(iamOperationsGatewayApiName, urlEncode`/accounts/${accountId}`)
        } catch (err) {
            if (axios.isAxiosError(err) && err.response?.status === 404) {
                return undefined
            }
            throw err
        }
    }

    public async getS2aAccounts(): Promise<S2aAccount[]> {
        return await SimpleApi.get(iamOperationsGatewayApiName, '/accounts')
    }

    public async setS2aAccountState(accountId: string, state: S2aAccountState.Active): Promise<S2aAccount>
    public async setS2aAccountState(
        accountId: string,
        state: S2aAccountState.Inactive,
        comment: string
    ): Promise<S2aAccount>
    public async setS2aAccountState(accountId: string, state: S2aAccountState, comment?: string): Promise<S2aAccount> {
        return await SimpleApi.put(iamOperationsGatewayApiName, `/accounts/${accountId}/${state}`, {
            body:
                state === S2aAccountState.Inactive
                    ? {
                          deactivateComment: comment,
                          deactivatedAt: new Date().toISOString()
                      }
                    : {}
        })
    }

    public async getS2aServices(): Promise<S2aService[]> {
        return await SimpleApi.get(iamOperationsGatewayApiName, '/services')
    }

    public async updateS2a(account: S2aAccount): Promise<S2aAccount> {
        const params = {
            body: account
        }

        return await SimpleApi.put(iamOperationsGatewayApiName, '/accounts', params)
    }

    public async createS2a(account: S2aAccount): Promise<CreateCustomerResponse> {
        const params = {
            body: account
        }

        return await SimpleApi.post(iamOperationsGatewayApiName, '/accounts', params)
    }

    public async getCreateProgress(progressToken: string): Promise<GetCreateCustomerProgressResponse> {
        return await SimpleApi.get(iamOperationsGatewayApiName, urlEncode`/accounts/createstatus/${progressToken}`)
    }

    /**
     * Get country-region mapping
     *
     * @returns Promise to return all countries with regions
     */
    public async getRegionCountryMapping(): Promise<RegionCountry[]> {
        return await SimpleApi.get(ocPermissionGatewayApiName, '/region-country')
    }

    /**
     * Create or update the customer.
     *
     * @throws {Error} Validation errors
     *
     * @returns {Promise<any>} Put result
     */
    public async update(customer: Customer, customerId: string): Promise<void> {
        const path = urlEncode`/customer/${customerId}`
        const params = {
            body: this.mapCustomerToRequestBodyParams(customer)
        }

        return await SimpleApi.put(gatewayApiName, path, params)
    }

    public async createInOcPermissions(customerId: string, regionName: string): Promise<boolean> {
        const params = {
            body: {
                account: customerId,
                region: regionName
            }
        }
        return await isResolved(SimpleApi.post(ocPermissionGatewayApiName, '/account', params))
    }

    public async create(customer: Customer): Promise<void> {
        const params = {
            body: this.mapCustomerToRequestBodyParams(customer)
        }

        await SimpleApi.post(gatewayApiName, '/customer', params)
    }

    /**
     * Create or update users favorite customers.
     *
     * @throws {Error} Validation errors
     *
     * @returns {Promise<any>} Put result
     */
    public async updateFavoriteCustomers(usersFavoriteCustomers: string[]): Promise<void> {
        const path = urlEncode`/customer/favorite-customers`
        const params = {
            body: usersFavoriteCustomers
        }

        return await SimpleApi.put(gatewayApiName, path, params)
    }

    /**
     * Get users favorite customers by logged user
     *
     * @returns Promise to return favorite customers by logged user
     */
    public async getUsersFavoriteCustomers(): Promise<string[]> {
        const path = urlEncode`/customer/favorite-customers`

        return await SimpleApi.get(gatewayApiName, path)
    }

    private mapCustomerToRequestBodyParams(customer: Customer) {
        return {
            s2aAccountName: customer.s2aAccountName,
            orderNumbersSyskron: customer.orderNumbersSyskron ?? [],
            quotationNumberKrones: customer.quotationNumberKrones || null,
            quotationNumberSyskron: customer.quotationNumberSyskron || null,
            street: customer.street || null,
            city: customer.city || null,
            stateName: customer.stateName || null,
            country: customer.country || null,
            zipCode: customer.zipCode || null,
            latitude: customer.latitude || null,
            longitude: customer.longitude || null,
            customerTimezone: customer.customerTimezone || null,
            salesRegion: customer.salesRegion || null,
            version: customer.version,
            customerNumber: customer.customerNumber || null,
            salesRepresentative: customer.salesRepresentative || null,
            accountProperties: customer.accountProperties,
            links: customer.links,
            readyKitCount: customer.readyKitCount,
            rkMonitoringHidden: customer.rkMonitoringHidden,
            preferredLanguages: customer.preferredLanguages ?? [],
            serviceGroups: customer.serviceGroups ?? []
        }
    }
}
